<template>
  <el-card>
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'blacklist'}">
          Restricted User names
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="username-blacklist">
      <el-tag
        size="small"
        :key="name"
        v-for="name in usernames"
        :closable="true"
        :close-transition="false"
        @close="remove(name)">
        {{name}}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="mini"
        @keyup.esc.native="handleInputCancel"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm">
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Name</el-button>
    </div>
    <el-button type="primary" @click="update()">Update</el-button>
    <el-button @click="reload">Reload</el-button>
  </el-card>
</template>

<style lang="scss">

.username-blacklist {
  margin-right: -10px;
  margin-bottom: 10px;

  .el-tag {
    margin: 0 10px 10px 0;
  }
  .button-new-tag {
    height: 24px;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0 10px 10px 0;
  }
  .input-new-tag {
    width: 93px;
    margin: 0 10px 10px 0;
    vertical-align: bottom;
  }
  .input-new-tag .el-input__inner {
    height: 24px;
  }
}
</style>


<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      inputVisible: false,
      inputValue: '',
      usernames: []
    }
  },

  computed: {
    ...mapState('blacklists', {
      originalUsernames: state => state.usernames
    })
  },

  watch: {
    originalUsernames () {
      this.usernames = [...this.originalUsernames]
    }
  },

  methods: {
    ...mapActions('blacklists', [
      'fetchUsernames',
      'updateUsernames'
    ]),
    remove (name) {
      this.usernames.splice(this.usernames.indexOf(name), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.usernames.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleInputCancel () {
      this.inputVisible = false
      this.inputValue = ''
    },
    update () {
      this.updateUsernames(this.usernames)
    },
    reload () {
      this.usernames = [...this.originalUsernames]
    }
  },

  mounted () {
    this.fetchUsernames()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/Blacklist.vue